import { useVendorVisible } from '~/api/work_order'

export const usePermittedFilters = filtersConfig => {
  const { isVendorVisible } = useVendorVisible()
  return filtersConfig.filter(f => {
    if (!isVendorVisible) return f.id !== 'vendor' && f.id !== 'vendor_name'
    return f
  })
}
